import { useEffect, useState } from 'react';

export function useScreenWidth() {
  const [width, setWidth] = useState(10000);

  useEffect(() => {
    setWidth(window.innerWidth);

    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { width };
}
